import React, { useState } from "react";
import Accordion from "../Accordion";
import Heading2 from "../Typography/Heading2";
import Heading3 from "../Typography/Heading3";
import OutboundLink from "../OutboundLink";

const HomepageFAQ = () => {
  const FAQ = [
    {
      header: "How much does Juicebox cost? Can I use it for free?",
      content: (
        <Heading3 inline={true}>
          The trial lets you build and share unlimited data presentations free
          for 14 days. More pricing details{" "}
          <OutboundLink
            text="here"
            href="https://www.juiceanalytics.com/juicebox-pricing"
          />
          .
        </Heading3>
      )
    },
    {
      header: "How do I connect my data to Juicebox?",
      content: (
        <Heading3 inline={true}>
          You can upload your data in comma delimited format (CSV) or as Excel
          files. Our Pro plan supports direct database connections.
        </Heading3>
      )
    },
    {
      header: "What is Juicebox best for?",
      content: (
        <Heading3 inline={true}>
          Juicebox lets you combine data exploration (through connected,
          interactive visualizations) with text and images so you can guide your
          users’ experience. People use Juicebox to create client presentations,
          research reports, data-rich sales pitches, interactive infographics,
          and customer reporting. See some examples of Juicebox apps{" "}
          <OutboundLink
            text="here"
            href="https://www.juiceanalytics.com/juicebox-app-gallery"
          />
          .
        </Heading3>
      )
    },
    {
      header: "How do I share the data presentations I make in Juicebox?",
      content: (
        <Heading3 inline={true}>
          Your data presentation can be set to public (no sign-in required) or
          private (users need to sign-in). You decide who you want to share
          with, and whether those people have viewer or editor access.
        </Heading3>
      )
    },
    {
      header: "Do I need to be a data expert to use Juicebox?",
      content: (
        <Heading3 inline={true}>
          No. It is helpful to be familiar with how data is structured for Excel
          Pivot Tables.
        </Heading3>
      )
    },
    {
      header:
        "Can Juicebox data presentations be integrated with my existing site?",
      content: (
        <Heading3 inline={true}>
          Yes. Our customers often use iFrames to embed Juicebox data
          presentations in their website. In addition, we can connect to your
          existing database.
        </Heading3>
      )
    },
    {
      header:
        "Where can I find out more about the thinking that went into Juicebox?",
      content: (
        <Heading3 inline={true}>
          <OutboundLink
            icon={[]}
            text="Juice Analytics"
            href="https://www.juiceanalytics.com/"
          />{" "}
          is the team behind Juicebox. We’re passionate about helping everyone
          communicate using data. If you’re just getting started, we share our
          <OutboundLink
            icon={[]}
            text="best thinking"
            href="https://www.juiceanalytics.com/writing"
          />{" "}
          on topics from data fluency{" "}
          <OutboundLink
            icon={[]}
            text="(we wrote the book on it)"
            href="https://www.juiceanalytics.com/data-fluency"
          />{" "}
          to{" "}
          <OutboundLink
            icon={[]}
            text="data visualization and storytelling."
            href="https://www.juiceanalytics.com/white-papers-guides-and-more"
          />
        </Heading3>
      )
    }
  ];
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="center flex flex-column items-center">
      <Heading2 weight="fw7">Frequently Asked Questions</Heading2>
      <div className="center mw7 mt4">
        {FAQ.map((f, i) => (
          <Accordion
            key={i}
            i={i}
            expanded={expanded}
            setExpanded={setExpanded}
            header={f.header}
            content={f.content}
            containerClassNames="bg-black-05 hover-bg-black-10 br2 mb2 overflow-hidden pa3"
            headerColor="accent"
          />
        ))}
      </div>
    </div>
  );
};

export default HomepageFAQ;
